export interface ProjectCardProps {
  name: string;
  description: string;
  imageLink: string;
  link?: string;
}
const ProjectCard = (props: ProjectCardProps) => {
  const { name, description, imageLink, link } = props;
  return (
    <li className="mb-12">
      <div className="group relative grid gap-4 pb-1 transition-all sm:grid-cols-8 sm:gap-8 md:gap-4 lg:hover:!opacity-100 lg:group-hover/list:opacity-50">
        <div className="absolute -inset-x-4 -inset-y-4 z-0 hidden rounded-xl transition motion-reduce:transition-none lg:-inset-x-6 lg:block lg:group-hover:bg-gradient-to-br lg:group-hover:from-fuchsia-400/10 lg:group-hover:via-slate-800/40 lg:group-hover:to-indigo-400/10 lg:group-hover:shadow-[0_0_40px_-12px_rgba(217,70,239,0.35)] lg:group-hover:ring-1 lg:group-hover:ring-inset lg:group-hover:ring-white/10 lg:group-hover:backdrop-blur-sm"></div>
        <div className="z-10 sm:order-2 sm:col-span-6">
          <h3 className="font-display">
            {link ? (
              <a
                className="inline-flex items-baseline font-medium leading-tight text-slate-200 hover:text-fuchsia-300 focus-visible:text-fuchsia-300 group/link text-base"
                href={link}
                target="_blank"
                rel="noreferrer"
                aria-label={name}
              >
                <span className="absolute -inset-x-4 -inset-y-2.5 hidden rounded md:-inset-x-6 md:-inset-y-4 lg:block"></span>
                <span>
                  {name}

                  <span className="inline-block">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="inline-block h-4 w-4 shrink-0 transition-transform group-hover/link:-translate-y-1 group-hover/link:translate-x-1 group-focus-visible/link:-translate-y-1 group-focus-visible/link:translate-x-1 motion-reduce:transition-none ml-1 translate-y-px"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.22 14.78a.75.75 0 001.06 0l7.22-7.22v5.69a.75.75 0 001.5 0v-7.5a.75.75 0 00-.75-.75h-7.5a.75.75 0 000 1.5h5.69l-7.22 7.22a.75.75 0 000 1.06z"
                        clipRule="evenodd"
                      ></path>
                    </svg>
                  </span>
                </span>
              </a>
            ) : (
              <span className="inline-flex items-baseline font-medium leading-tight text-slate-200 text-base">
                {name}
              </span>
            )}
          </h3>
          <p className="mt-2 text-sm leading-normal">{description}</p>
        </div>
        <img
          alt=""
          loading="lazy"
          width="200"
          height="48"
          decoding="async"
          data-nimg="1"
          className="rounded-lg border-2 border-slate-200/10 transition group-hover:border-fuchsia-300/30 group-hover:shadow-[0_0_20px_-6px_rgba(217,70,239,0.5)] sm:order-1 sm:col-span-2 sm:translate-y-1"
          style={{ color: "transparent" }}
          src={imageLink}
        />
      </div>
    </li>
  );
};
export default ProjectCard;
